import { createFeatureSelector, createSelector } from '@ngrx/store';

import { Category } from '../router/category';
import * as fromAppSetting from './app-settings.reducer';
import { CategoryApplicationSetting, CategoryApplicationSettingState } from './app-settings.state';

export const selectCategoryApplicationSettingsState = createFeatureSelector<CategoryApplicationSettingState>(
  'category-application-settings'
);

export const selectCategoryApplicationSettingsIds = createSelector(
  selectCategoryApplicationSettingsState,
  fromAppSetting.selectAppSettingsIds
);

export const selectCategoryApplicationSettingsEntities = createSelector(
  selectCategoryApplicationSettingsState,
  fromAppSetting.selectAppSettingsEntities
);

export const selectAllCategoryApplicationSettings = createSelector(
  selectCategoryApplicationSettingsState,
  fromAppSetting.selectAllAppSettings
);

export const selectSettingsForCurrentCategory = (category: Category) =>
  createSelector(selectAllCategoryApplicationSettings, (settings: CategoryApplicationSetting[]) => {
    if (!category || !settings) {
      return [];
    }

    return settings.filter(
      (setting) => setting.categoryType === category.categoryType && setting.categoryId === category.categoryId
    );
  });

export const selectSettingsForCurrent = (bundleId: string, category: Category) =>
  createSelector(selectAllCategoryApplicationSettings, (settings: CategoryApplicationSetting[]) => {
    if (!category || !settings) {
      return [];
    }

    const uniqueSettings = new Map<string, CategoryApplicationSetting>();

    // Recursively process categories from bottom up (most specific to least specific)
    const processCategory = (currentCategory: Category) => {
      // Then process current category settings
      const categorySettings = settings.filter(
        (setting) =>
          setting.categoryType === currentCategory.categoryType &&
          setting.categoryId === currentCategory.categoryId &&
          setting.bundleIdentifier === bundleId
      );

      // Add settings to map (only if key doesn't exist, ensuring lower categories override higher ones)
      categorySettings.forEach((setting) => {
        const settingKey = setting.key;
        if (!uniqueSettings.has(settingKey)) {
          uniqueSettings.set(settingKey, setting);
        }
      });

      // Last process inherited categories (bottom up)
      if (currentCategory.parent) {
        processCategory(currentCategory.parent);
      }
    };

    processCategory(category);
    return Array.from(uniqueSettings.values());
  });
